/**
 * @generated SignedSource<<33971c60e0cc640169ccb7ce9be9a85d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ownerDistributionsRow_Query$variables = {
  year?: number | null | undefined;
};
export type ownerDistributionsRow_Query$data = {
  readonly allStakeholders: ReadonlyArray<{
    readonly cxid: string;
    readonly distribution: boolean;
    readonly id: string;
    readonly name: string;
  }>;
  readonly ownerDistributions: ReadonlyArray<{
    readonly flagged: boolean;
    readonly points: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly stakeholder: {
      readonly id: string;
      readonly name: string;
    };
    readonly yearTotal: number;
  }>;
};
export type ownerDistributionsRow_Query = {
  response: ownerDistributionsRow_Query$data;
  variables: ownerDistributionsRow_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "year"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "year",
    "variableName": "year"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Stakeholder",
  "kind": "LinkedField",
  "name": "stakeholder",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flagged",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "yearTotal",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Stakeholder",
  "kind": "LinkedField",
  "name": "allStakeholders",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cxid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "distribution",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ownerDistributionsRow_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "OwnerDistributionRow",
        "kind": "LinkedField",
        "name": "ownerDistributions",
        "plural": true,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "points",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v9/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ownerDistributionsRow_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "OwnerDistributionRow",
        "kind": "LinkedField",
        "name": "ownerDistributions",
        "plural": true,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "points",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      (v9/*: any*/)
    ]
  },
  "params": {
    "cacheID": "45c182334ae6bfa495108ebb6886da18",
    "id": null,
    "metadata": {},
    "name": "ownerDistributionsRow_Query",
    "operationKind": "query",
    "text": "query ownerDistributionsRow_Query(\n  $year: Int\n) {\n  ownerDistributions(year: $year) {\n    stakeholder {\n      id\n      name\n    }\n    flagged\n    yearTotal\n    points {\n      month\n      value\n      id\n    }\n    id\n  }\n  allStakeholders {\n    id\n    name\n    cxid\n    distribution\n  }\n}\n"
  }
};
})();

(node as any).hash = "b0c923004bffbb71a5310cab36881379";

export default node;
